import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import AddProductForm from "./addForm";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useProductHook from "./useProductHook";

const AddProduct = () => {
  const [menu, setMenu] = useState(false);
  const { id } = useParams();
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const { FetchSingleProduct } = useProductHook();
  const { Product, ProductLoading } = FetchSingleProduct(id);
  console.log("Product data:", Product, "Loading state:", ProductLoading);
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={toggleMobileMenu} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="card mb-0">
            <div className="card-body">
              <div className="page-header">
                <div className="content-page-header">
                  <h5>Edit Product</h5>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group-item">
                    <h5 className="form-title">Basic Details</h5>
                    {!ProductLoading && (
                      <AddProductForm
                        toggleMobileMenu={toggleMobileMenu}
                        isEdit={Boolean(id)}
                        id={id}
                        data={Product}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddProduct;
